import { Capacitor } from '@capacitor/core'
import { posService } from './POSService'
import tabService from './TabService'

export function shouldUseNativeReceiptPdfShare () {
  if (!Capacitor.isNativePlatform()) return false
  const platform = Capacitor.getPlatform()
  return platform === 'ios' || platform === 'android'
}

/** @deprecated Use shouldUseNativeReceiptPdfShare */
export function shouldUseIosReceiptShare () {
  return shouldUseNativeReceiptPdfShare()
}

/**
 * Fetch server PDF, write to cache, open native share sheet (Print, AirDrop, Files, …).
 */
export async function shareReceiptPdfOnIos (saleId) {
  if (!shouldUseNativeReceiptPdfShare()) {
    throw new Error('Native receipt share is only available on Capacitor iOS/Android')
  }
  const { shareReceiptPdfNative } = await import('./receiptShareIos.native.js')
  await shareReceiptPdfNative(saleId, (id) => posService.downloadReceiptPdf(id))
}

export async function shareTabStatementPdfOnIos (tabId) {
  if (!shouldUseNativeReceiptPdfShare()) {
    throw new Error('Native tab statement share is only available on Capacitor iOS/Android')
  }
  const { shareTabStatementPdfNative } = await import('./receiptShareIos.native.js')
  await shareTabStatementPdfNative(tabId, (id) => tabService.downloadStatementPdf(id))
}
